import{renderIcon as n}from"../icon.renderer.js";const o="minus",r=["minus",n({outline:'<path d="M26,17H10a1,1,0,0,0,0,2H26a1,1,0,0,0,0-2Z"/>'})];export{r as minusIcon,o as minusIconName};
